import React, { useEffect } from "react";
import "./IOT.css";
import { Cpu, Activity, Cloud, Shield, Zap, BarChart3 } from "lucide-react";

// Import shared components
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import ERPChatbot from "../../components/ERPChatbot/ERPChatbot";
import iot from "../../assets/iot.png";
import Realtime from "../../assets/Realtime.png";
import supplychain from "../../assets/supplychain.png";
import energy from "../../assets/energy.png";

export default function IOT() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="iot-page">
        {/* Hero Section */}
        <section
          className="iot-hero"
           style={{ backgroundImage: `url(${iot})` }}
        >
          <div className="iot-hero-overlay"></div>
          <h1 className="iot-hero-title">
            Transform Your Factory into a Smart, Data-Driven Enterprise
          </h1>
          <p className="iot-hero-subtitle">
            Unlock unprecedented efficiency, quality, and agility by connecting
            your physical and digital worlds.
          </p>
        </section>

        {/* Intro Section */}
        <section className="iot-intro">
          <h2>What is Industrial IoT (IIoT) in Manufacturing?</h2>
          <p>
            IIoT is the application of the Internet of Things (IoT) within
            industrial settings, particularly manufacturing. It involves a
            network of smart sensors, devices, and machinery that collect and
            share data in real-time. This data is analyzed using AI and Machine
            Learning to optimize every aspect of the process, from the shop
            floor to the supply chain.
          </p>
        </section>

        {/* Key Components Section */}
        <section className="iot-benefits">
          <h2>Key Components of Our IIoT Solution</h2>
          <div className="iot-benefit-cards">
            <div className="iot-benefit-card">
              <Cpu className="benefit-icon" />
              <h3>Smart Sensors & Devices</h3>
              <p>
                Monitor temperature, vibration, pressure, and energy consumption
                across your entire facility.
              </p>
            </div>
            <div className="iot-benefit-card">
              <Cloud className="benefit-icon" />
              <h3>Industrial Gateways</h3>
              <p>
                Securely aggregate and transmit shop floor data to cloud or
                on-premise servers.
              </p>
            </div>
            <div className="iot-benefit-card">
              <BarChart3 className="benefit-icon" />
              <h3>Data Analytics Platform</h3>
              <p>
                Convert massive data streams into actionable dashboards and
                reports in real time.
              </p>
            </div>
            <div className="iot-benefit-card">
              <Zap className="benefit-icon" />
              <h3>Cloud / Edge Computing</h3>
              <p>
                Real-time edge processing and scalable cloud storage for maximum
                flexibility.
              </p>
            </div>
          </div>
        </section>

        {/* Core Benefits Section */}
        <section className="iot-capabilities">
          <h2>Core Benefits of Implementing IIoT</h2>
          <div className="iot-capability-cards">
            <div className="iot-capability-card">
              <Activity className="benefit-icon" />
              <h3>Increased Operational Efficiency</h3>
              <p>
                Gain real-time visibility into performance to identify
                bottlenecks and boost productivity.
              </p>
            </div>
            <div className="iot-capability-card">
              <Shield className="benefit-icon" />
              <h3>Predictive Maintenance</h3>
              <p>
                Detect anomalies early to prevent unplanned downtime and extend
                machine life.
              </p>
            </div>
            <div className="iot-capability-card">
              <Cpu className="benefit-icon" />
              <h3>Enhanced Quality Assurance</h3>
              <p>
                Monitor production conditions to ensure consistent quality and
                reduce defects.
              </p>
            </div>
            <div className="iot-capability-card">
              <Zap className="benefit-icon" />
              <h3>Improved Worker Safety</h3>
              <p>
                Connected wearables and sensors alert workers of hazardous
                conditions in real time.
              </p>
            </div>
          </div>
        </section>

        {/* Applications Section — Alternating Layout */}
        <section className="iot-applications">
          <h2>Key IIoT Applications on the Shop Floor</h2>

          <div className="iot-app-row">
            <div className="iot-app-image">
              <img src={Realtime} alt="Real-Time Monitoring" />

            </div>
            <div className="iot-app-text">
              <h3>Real-Time Production Monitoring</h3>
              <p>
                Get a live, centralized view of your facility — track OEE, cycle
                times, and KPIs across all production lines for faster decision
                making.
              </p>
            </div>
          </div>

          <div className="iot-app-row reverse">
            <div className="iot-app-text">
              <h3>Supply Chain Visibility & Asset Tracking</h3>
              <p>
                Track raw materials and finished goods in real time. Monitor
                environmental conditions like temperature and humidity for full
                traceability.
              </p>
            </div>
            <div className="iot-app-image">
              
               <img src={supplychain} alt="Supply Chain" />
            </div>
          </div>

          <div className="iot-app-row">
            <div className="iot-app-image">
             
               <img src={energy} alt="Energy Management" />
            </div>
            <div className="iot-app-text">
              <h3>Energy Management</h3>
              <p>
                Connect energy meters and machines to pinpoint wastage, optimize
                consumption, and reduce operating costs intelligently.
              </p>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="iot-stats">
          <div className="stat">
            <h3>25%</h3>
            <p>Higher Equipment Uptime</p>
          </div>
          <div className="stat">
            <h3>30%</h3>
            <p>Reduction in Energy Costs</p>
          </div>
          <div className="stat">
            <h3>40%</h3>
            <p>Faster Decision Making</p>
          </div>
        </section>
      </div>

      <ERPChatbot />
      <Footer />
    </>
  );
}
